
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import { createSize, isHitSuffix } from '@/common/utils'
import { curry, uniqueId } from 'lodash'
import { ElForm } from 'element-ui/types/form'
import { createFilename } from '@/components/chat_record/index.vue'
import { commentTypes } from '@/settings/online'
import { getRequiredMsg, getSizeMsg } from '@/template/rule'
import UploadFile from '@/common/class/UploadImg'
import FilePlus from '@/common/class/FilePlus'
// @ts-ignore
import JpgIcon from '@/assets/common_images/jpg.png'
// @ts-ignore
import pdfIcon from '@/assets/common_images/pdf.png'
// @ts-ignore
import wordIcon from '@/assets/common_images/word.png'
// @ts-ignore
import musicIcon from '@/assets/common_images/music.png'

// 最多选择文件数量
const FILE_LIMIT_NUMBER = 5
const fSOption = { size: 5, type: 'MB' }
// @ts-ignore
const fileSize = createSize(fSOption)
const iconMap = new Map([
    ['photo', JpgIcon],
    ['pdf', pdfIcon],
    ['word', wordIcon],
    ['mp3', musicIcon]
])
// 上传状态
const uploadStatus = {
    ing: 'ing',
    success: 'success',
    fail: 'fail'
}

/**
 * @prop closed 协助已关闭
*/
@Component({
    name: 'order-comment'
})
export default class extends Vue {
    @Ref('commentFormRef') private formEl!: ElForm
    @Prop({ default: false }) private closed!: boolean

    // @variable declare
    private fileList!: any[]
    private commentRules!: any
    private calcNumber!: number         // 统计发起评论的次数
    private status!: any

    private commentForm = {
        reply: ''
    }
    private buttonText = '发送'
    private sendLoading = false
    private fileNameList: any[] = []
    private placeholder = '请输入您的回复，在这里进行沟通'

    get isShowFileSelector() {
        if (this.closed) {
            return false
        }
        return this.fileNameList.length < FILE_LIMIT_NUMBER
    }
    get fileTooltip() {
        const fileSupport = ['DOC', 'DOCX', 'JPG', 'PNG', 'PDF', 'MP3', 'JPEG']
        const sizeType = `${fSOption.size}${fSOption.type}`
        return `最多支持${FILE_LIMIT_NUMBER}个附件，大小不得超过${sizeType}。支持${fileSupport.join('、')}格式。`
    }
    @Watch('closed')
    private watchClosed(val: boolean) {
        val && this.banAction()
    }

    created() {
        this.status = uploadStatus
        this.calcNumber = 0
        this.fileList = []
        this.commentRules = {
            reply: [
                { validator: this.commentValidator, trigger: 'none' }
            ]
        }
        this.closed && this.banAction()
    }
    onSelectFile() {
        // 检测文件数量
        (this.$refs.fileEl as any).click()
    }
    onFileSelected(event: any) {
        const file = event.target.files[0]
        // 检查文件类型
        const suffixs = ['.doc', '.docx', '.jpg', '.png', '.pdf', '.mp3', '.jpeg']
        const fp = new FilePlus(file, { size: fileSize, customSuffix: suffixs })
        this.resetFileEl()
        if (fp.hasSuffixError) {
            return this.$mwarning('请正确地选择文件类型')
        }
        if (fp.hasSizeError) {
            return this.$mwarning(`文件大小不得超过 ${fSOption.size} ${fSOption.type}`)
        }
        const id = uniqueId()
        this.fileNameList.push(this.createFileInfo(file, { id, status: '' }))
        this.fileList.push({ id, origin: file })
    }
    onDeleteFile(event: any) {
        const { id } = event.target.dataset
        if (id == null) {
            return
        }
        // 二次确认
        this.$confirm('正在删除文件, 是否继续', { type: 'warning' })
            .then(() => {
                const deleteItem = (list: any[], id: any) => list.filter(n => n.id !== id)
                this.fileNameList = deleteItem(this.fileNameList, id)
                this.fileList = deleteItem(this.fileList, id)
            })
            .catch(() => {})
    }
    resetFileEl() {
        (this.$refs.fileEl as any).value = ''
    }
    createFileInfo(file: any, extra: any = {}) {
        const isValidSuffix = (suffixs: string[], filename: string) => isHitSuffix(filename, suffixs) 
        const isPdf = curry(isValidSuffix)(['.pdf'])
        const isWord = curry(isValidSuffix)(['.doc', '.docx'])
        const isMp3 = curry(isValidSuffix)(['.mp3'])
        const isPhoto = curry(isValidSuffix)(['.jpg', '.png', '.jpeg'])
        const filename = file.name

        let info = { 
            ...extra,
            name: createFilename(filename), 
            icon: ''
        }

        if (isPdf(filename)) {
            info.icon = iconMap.get('pdf')
            info.fileType = 'pdf'
            info.type = commentTypes.file.value
            return info
        } else if (isWord(filename)) {
            info.icon = iconMap.get('word')
            info.fileType = 'word'
            info.type = commentTypes.file.value
            return info
        } else if (isMp3(filename)) {
            info.icon = iconMap.get('mp3')
            info.fileType = 'mp3'
            info.type = commentTypes.file.value
            return info
        } else if (isPhoto(filename)) {
            info.icon = iconMap.get('photo')
            info.fileType = 'photo'
            info.type = commentTypes.photo.value
            return info
        }

        return info
    }
    reset() {
        this.formEl.resetFields()
        // 重置文件
        this.fileList = []
        this.fileNameList = []
    }
    commentValidator(rule: any, value: string, callback: Function) {
        const MAX_LEN = 300
        if (!this.fileList.length) {
            if (!value) {
                callback(new Error(getRequiredMsg('内容')))
            } else if (value.length > MAX_LEN) {
                callback(new Error(getSizeMsg('内容', { min: 0, max: MAX_LEN })))
            }
            callback()
        } else {
            callback()
        }
    }
    onSendComment() {
        this.formEl.validate(isValid => {
            if (!isValid) {
                return
            }
            this.sendLoading = true
            // 发起文字评论
            if (this.commentForm.reply) {
                this.$emit('comment', {
                    message: this.commentForm.reply,
                    type: commentTypes.text.value,
                    success: () => {
                        if (!this.fileNameList.length) {
                            this.sendLoading = false
                        }
                        this.formEl.resetFields()
                    },
                    fail: () => {
                        this.sendLoading = false
                    } 
                })
            }
            // 发起上传文件评论
            if (this.fileNameList.length) {
                this.buttonText = '上传文件'
                const originLen = this.fileNameList.length
                const isLast = () => this.calcNumber === originLen
                const lastCallBack = () => {
                    this.calcNumber = 0
                    this.buttonText = '发送'
                    this.sendLoading = false
                }
                this.fileList.forEach(async (n) => {
                    // 根据 n.id 去找对应的文件名项目
                    const fileItem = this.fileNameList.find(m => m.id === n.id)
                    if (fileItem) {
                        // 显示上传中
                        fileItem.status = uploadStatus.ing 
                        const result = await new UploadFile(n.origin, 'file').upload()
                        // 判断上传结果
                        if (result.error) {
                            this.calcNumber += 1
                            fileItem.status = uploadStatus.fail
                            isLast() && lastCallBack()
                            return
                        }
                        this.$emit('comment', {
                            url: result.key,
                            filename: n.origin.name,
                            type: fileItem.type,
                            fileType: fileItem.fileType,
                            success: () => {
                                this.calcNumber += 1
                                fileItem.status = uploadStatus.success
                                this.fileList = this.fileList.filter(n => n.id !== fileItem.id)
                                this.fileNameList = this.fileNameList.filter(n => n.id !== fileItem.id)
                                isLast() && lastCallBack()
                            },
                            fail: () => {
                                this.calcNumber += 1
                                fileItem.status = uploadStatus.fail
                                isLast() && lastCallBack()
                            }
                        })
                    }
                })
            }
        })
    }
    matchFilename(file: any) {
        if (file.status === uploadStatus.ing) {
            return '上传中'
        }
        if (file.status === uploadStatus.success) {
            return '上传成功'
        }
        if (file.status === uploadStatus.fail) {
            return file.name
        }
        return file.name
    }
    // 协助关闭检测
    banAction() {
        this.commentForm.reply = ''
        this.placeholder = '该协助已结束服务'
    }
}
